export default "__VITE_PUBLIC_ASSET__b5770a92__"